module.exports = __webpack_public_path__ + "media/images/asd-2663ae18e9f32a2c781f87582edd05a8.png";